import React, { useEffect, useState } from "react";
import { data } from "./data";
import "./styles.scss";

const LiveProjects = ({ project }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 800);
    };

    // Set initial value
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // Filter the data based on the condition
  const filteredData =
    project === "part-time"
      ? data.filter((_, index) => index !== 2) // Exclude the third item (index 2)
      : data;

  return (
    <div className="mlp-project-card-container">
      {filteredData.map((project, index) => (
        <div
          id={`mlp-sticky-card-${index + 1}`}
          key={index}
          className="mlp-sticky-card-div"
        >
          <div className="project-card">
            <div className="p-card">
              <div className="p-info">
                <div className="project-name" style={{ color: project.color }}>
                  {" "}
                  {project.project}
                </div>
                <div className="project-title"> {project.title}</div>
                <div className="duration">
                  Duration:{" "}
                  <span className="duration-val">{project.duration}</span>
                </div>

                <div
                  className="p-desc"
                  dangerouslySetInnerHTML={{ __html: project.desc }}
                />

                <ul>
                  {project.subdescription.map((subdesc, index) => (
                    <li
                      className="sub-desc"
                      key={index}
                      dangerouslySetInnerHTML={{ __html: subdesc }}
                    />
                  ))}
                </ul>

                <div className="p-disclaimer mobile-hide">
                  {project.disclaimer}
                </div>
              </div>
              {/* pc */}
              <div
                className="p-img mobile-hide"
                style={{ backgroundImage: `url(${project.bg})` }}
              >
                {/* icon at top right */}
                <div
                  style={{ backgroundImage: `url(${project.bgTopRight})` }}
                  className="bg-Top_Right"
                >
                  <img
                    src="https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46le5j6.png"
                    className="radioIcon"
                    alt="->"
                    loading="lazy"
                  />
                </div>

                <div className="p-img-body">
                  {project.points.map((point) => (
                    <div className="bullets">
                      <img
                        src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y3bdzm2t7kto4.png"
                        className="bulletImg"
                        alt="->"
                        loading="lazy"
                      />{" "}
                      {point}
                    </div>
                  ))}
                  <div
                    className="p-highlight"
                    style={{ color: project.hColor }}
                  >
                    <img
                      className="highlightImg"
                      src={`${project.icon}`}
                      loading="lazy"
                    />{" "}
                    {project.highlight}
                  </div>
                </div>

                <div className="ads-Images">
                  <img
                    src={project.AddIamge}
                    className=""
                    alt="->"
                    loading="lazy"
                  />
                </div>
              </div>
              {/* mobile */}
              <div
                className="p-img pc-none"
                style={{ backgroundImage: `url(${project.mobImg})` }}
              >
                {/* icon at top right */}
                <div
                  style={{ backgroundImage: `url(${project.bgTopRight})` }}
                  className="bg-Top_Right"
                >
                  <img
                    src="https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46le5j6.png"
                    className="radioIcon"
                    alt="->"
                    loading="lazy"
                  />
                </div>
                <div className="p-img-body">
                  {project.points.map((point) => (
                    <div className="bullets">
                      <img
                        src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y3bdzm2t7kto4.png"
                        className="bulletImg"
                        alt="->"
                        loading="lazy"
                      />{" "}
                      {point}
                    </div>
                  ))}
                  <div
                    className="p-highlight"
                    style={{ color: project.hColor }}
                  >
                    <img
                      className="highlightImg"
                      src={project.icon}
                      loading="lazy"
                    />{" "}
                    {project.highlight}
                  </div>
                </div>
                {/* ads section */}
                <div className="ads-Images">
                  {!isMobile && (
                    <img
                      src={project.AddIamge}
                      className="mobile-hide"
                      alt="->"
                      loading="lazy"
                    />
                  )}
                  {isMobile && (
                    <img
                      src={project.AddIamgeMob}
                      className="pc-hide"
                      alt="->"
                      loading="lazy"
                    />
                  )}
                </div>

                <div className="p-disclaimer" style={{ textAlign: "center" }}>
                  {project.disclaimer}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LiveProjects;
